<template>
  <video ref="videoPlayer" class="video-js vjs-fluid vjs-default-skin vjs-big-play-centered" preload="auto" />
</template>

<script>
// eslint-disable-next-line import/extensions,import/no-unresolved
import videojs from 'video.js';

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
      interval: null,
    };
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      console.log('onPlayerReady', this);
    });

    // this.interval = setInterval(() => {
    //   // console.log(this.player.paused());
    //   if (this.player.paused()) {
    //     this.player.load();
    //   }
    // }, 2000);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }

    // if (this.interval) {
    //   clearInterval(this.interval);
    // }
  },
};
</script>

<style scoped>

</style>
